<template>
  <div class="fixed top-0 z-50 w-full transition-shadow duration-500"
       :class="{'bg-white shadow-md': !withoutLogo || shouldHaveBg}">
    <nav class="lg:justify-between lg:items-center hidden px-5  pr-6 pb-5 mx-auto pt-5 lg:flex max-h-[100px] lg:max-w-[1600px]">
      <div class="w-[200px] ml-[4%]">
        <a :href='route("frontend.homepage")'>
          <img class="object-contain h-32" src="/assets/shopcamp.svg" alt="Shopcamp Logo">
          <!--              <img class="object-contain xl:hidden h-10" src="/assets/shopcamp-sm.svg" alt="Shopcamp Logo">-->
        </a>
      </div>
      <div class="flex items-center gap-1">
        <a
          class="text-xl lg:px-3 xl:px-[18px] px-2 my-2 transition-all duration-100 cursor-pointer md:mx-2 hover:opacity-75 text-body"
          style="text-wrap: nowrap"
          :class="[!textBlue ? 'text-white' : 'text-[#2699C6]']"
          v-for="(link, i) in links"
          :key="i"
          :href="link.href"
        >{{ link.name }}</a
        >


                <Button :href="route('frontend.registration')" v-if="registrationOpened && !userLoggedIn" class="flex items-center ml-10 mr-2 py-[8px] text-white transition-all duration-200 text-body hover:opacity-80 bg-brand-blue">
                  <svg class="mr-2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.1338 2.44629C19.0197 2.45032 18.9045 2.46544 18.791 2.49219L3.88184 6H10.4316L19.1348 3.95215C19.2223 3.93015 19.2897 3.96242 19.3232 3.98242C19.3557 4.00292 19.4141 4.04969 19.4346 4.13769L19.8809 6H21.4141L20.8955 3.79492C20.7885 3.33992 20.5108 2.95303 20.1133 2.70703C19.8148 2.52253 19.4762 2.43419 19.1338 2.44629ZM3.25 7C2.29252 7 1.5 7.79252 1.5 8.75V11.2646C1.50003 11.371 1.52265 11.4761 1.56638 11.573C1.6101 11.6699 1.67392 11.7564 1.75362 11.8267C1.83331 11.8971 1.92705 11.9497 2.02862 11.9811C2.13019 12.0125 2.23728 12.0219 2.34277 12.0088C2.38843 12.0031 2.44441 12 2.5 12C3.61539 12 4.5 12.8846 4.5 14C4.5 15.1154 3.61539 16 2.5 16C2.44441 16 2.38843 15.9969 2.34277 15.9912C2.23728 15.9781 2.13019 15.9875 2.02862 16.0189C1.92705 16.0503 1.83331 16.1029 1.75362 16.1733C1.67392 16.2436 1.6101 16.3301 1.56638 16.427C1.52265 16.5239 1.50003 16.629 1.5 16.7353V19.25C1.5 20.2075 2.29252 21 3.25 21H20.75C21.7075 21 22.5 20.2075 22.5 19.25V16.7353C22.5 16.629 22.4773 16.5239 22.4336 16.427C22.3899 16.3301 22.3261 16.2436 22.2464 16.1733C22.1667 16.1029 22.073 16.0503 21.9714 16.0189C21.8698 15.9875 21.7627 15.9781 21.6572 15.9912C21.6116 15.9969 21.5556 16 21.5 16C20.3846 16 19.5 15.1154 19.5 14C19.5 12.8846 20.3846 12 21.5 12C21.5556 12 21.6116 12.0031 21.6572 12.0088C21.7627 12.0219 21.8698 12.0125 21.9714 11.9811C22.073 11.9497 22.1667 11.8971 22.2464 11.8267C22.3261 11.7564 22.3899 11.6699 22.4336 11.573C22.4773 11.4761 22.5 11.371 22.5 11.2646V8.75C22.5 7.79252 21.7075 7 20.75 7H3.25ZM3.25 8.5H20.75C20.8975 8.5 21 8.60248 21 8.75V10.6016C19.3203 10.8554 18 12.2525 18 14C18 15.7475 19.3203 17.1446 21 17.3984V19.25C21 19.3975 20.8975 19.5 20.75 19.5H3.25C3.10248 19.5 3 19.3975 3 19.25V17.3984C4.67974 17.1446 6 15.7475 6 14C6 12.2525 4.67974 10.8554 3 10.6016V8.75C3 8.60248 3.10248 8.5 3.25 8.5Z" fill="white"/>
                  </svg>
                  Vstupenky
                </Button>

        <Button :href="route('frontend.login')" v-if="loginOpened && !userLoggedIn"
                class="ml-2 transition-all duration-200 border-2 py-[6px] rounded-full text-body hover:opacity-80"
                :class="!textBlue ? 'text-white border-white' : 'text-[#2699C6] border-[#2699C6]'">

          <svg class="mr-2" width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8 0C5.24746 0 3 2.24746 3 5C3 7.75254 5.24746 10 8 10C10.7525 10 13 7.75254 13 5C13 2.24746 10.7525 0 8 0ZM8 1.5C9.94188 1.5 11.5 3.05812 11.5 5C11.5 6.94188 9.94188 8.5 8 8.5C6.05812 8.5 4.5 6.94188 4.5 5C4.5 3.05812 6.05812 1.5 8 1.5ZM2.25 12C1.01625 12 0 13.0162 0 14.25V14.8496C0 16.32 0.932357 17.639 2.35449 18.5459C3.77663 19.4528 5.72242 20 8 20C10.2776 20 12.2234 19.4528 13.6455 18.5459C15.0676 17.639 16 16.32 16 14.8496V14.25C16 13.0162 14.9838 12 13.75 12H2.25ZM2.25 13.5H13.75C14.1732 13.5 14.5 13.8268 14.5 14.25V14.8496C14.5 15.6822 13.9637 16.5639 12.8389 17.2812C11.714 17.9986 10.0344 18.5 8 18.5C5.96558 18.5 4.286 17.9986 3.16113 17.2812C2.03627 16.5639 1.5 15.6822 1.5 14.8496V14.25C1.5 13.8268 1.82675 13.5 2.25 13.5Z"
              :fill="textBlue ? '#2699C6' : '#FFFFFF'"/>
          </svg>

          Přihlášení
        </Button>

        <Button :href="route('frontend.user-profile')" v-if="userLoggedIn"
                class="ml-2 transition-all duration-200 border-2 py-[6px] rounded-full text-body hover:opacity-80 whitespace-nowrap"
                :class="!textBlue ? 'text-white border-white' : 'text-[#2699C6] border-[#2699C6]'">

          <svg class="mr-2" width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8 0C5.24746 0 3 2.24746 3 5C3 7.75254 5.24746 10 8 10C10.7525 10 13 7.75254 13 5C13 2.24746 10.7525 0 8 0ZM8 1.5C9.94188 1.5 11.5 3.05812 11.5 5C11.5 6.94188 9.94188 8.5 8 8.5C6.05812 8.5 4.5 6.94188 4.5 5C4.5 3.05812 6.05812 1.5 8 1.5ZM2.25 12C1.01625 12 0 13.0162 0 14.25V14.8496C0 16.32 0.932357 17.639 2.35449 18.5459C3.77663 19.4528 5.72242 20 8 20C10.2776 20 12.2234 19.4528 13.6455 18.5459C15.0676 17.639 16 16.32 16 14.8496V14.25C16 13.0162 14.9838 12 13.75 12H2.25ZM2.25 13.5H13.75C14.1732 13.5 14.5 13.8268 14.5 14.25V14.8496C14.5 15.6822 13.9637 16.5639 12.8389 17.2812C11.714 17.9986 10.0344 18.5 8 18.5C5.96558 18.5 4.286 17.9986 3.16113 17.2812C2.03627 16.5639 1.5 15.6822 1.5 14.8496V14.25C1.5 13.8268 1.82675 13.5 2.25 13.5Z"
              :fill="textBlue ? '#2699C6' : '#FFFFFF'"/>
          </svg>
          <p class="mr-1">
            Můj profil</p>
        </Button>

      </div>

    </nav>
  </div>

  <Disclosure
    as="nav"
    class="fixed top-0 z-50 w-full bg-white border-b border-gray-200 lg:hidden"
    v-slot="{ open }"
  >
    <div class="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
      <div class="flex justify-between h-16">
        <div class="flex">
          <div class="flex items-center shrink-0">
            <a :href='route("frontend.homepage")'>
              <img class="h-10" src="/assets/shopcamp.svg" alt="Shopcamp Logo">
            </a>

          </div>
          <div class="hidden sm:-my-px sm:ml-6 lg:flex sm:space-x-8">
            <a
              v-for="item in links"
              :key="item.name"
              :href="item.href"
              :class="[
                item.current
                  ? 'border-indigo-500 text-gray-900'
                  : 'border-transparent text-white',
                'inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium',
              ]"
              :aria-current="item.current ? 'page' : undefined"
            >
              {{ item.name }}
            </a>
          </div>
        </div>
        <div class="flex items-center -mr-2 lg:hidden">
          <!-- Mobile menu button -->
          <DisclosureButton
            ref="toggle-button"
            class="inline-flex items-center justify-center p-2 text-gray-400 bg-white rounded-md hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            <span class="sr-only">Open main menu</span>
            <MenuIcon v-if="!open" class="block w-6 h-6" aria-hidden="true"/>
            <XIcon v-else class="block w-6 h-6" aria-hidden="true"/>
          </DisclosureButton>
        </div>
      </div>
    </div>

    <DisclosurePanel class="lg:hidden">
      <div class="pt-2 pb-3 space-y-1" style="justify-items: center">

        <Button :href="route('frontend.login')" v-if="loginOpened && !userLoggedIn"
                class="ml-4 transition-all max-w-[300px] mb-2 duration-200 bg-white border-2 py-[6px] rounded-full text-[#2699C6] text-body hover:opacity-80 border-brand-blue">

          <svg class="mr-2" width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8 0C5.24746 0 3 2.24746 3 5C3 7.75254 5.24746 10 8 10C10.7525 10 13 7.75254 13 5C13 2.24746 10.7525 0 8 0ZM8 1.5C9.94188 1.5 11.5 3.05812 11.5 5C11.5 6.94188 9.94188 8.5 8 8.5C6.05812 8.5 4.5 6.94188 4.5 5C4.5 3.05812 6.05812 1.5 8 1.5ZM2.25 12C1.01625 12 0 13.0162 0 14.25V14.8496C0 16.32 0.932357 17.639 2.35449 18.5459C3.77663 19.4528 5.72242 20 8 20C10.2776 20 12.2234 19.4528 13.6455 18.5459C15.0676 17.639 16 16.32 16 14.8496V14.25C16 13.0162 14.9838 12 13.75 12H2.25ZM2.25 13.5H13.75C14.1732 13.5 14.5 13.8268 14.5 14.25V14.8496C14.5 15.6822 13.9637 16.5639 12.8389 17.2812C11.714 17.9986 10.0344 18.5 8 18.5C5.96558 18.5 4.286 17.9986 3.16113 17.2812C2.03627 16.5639 1.5 15.6822 1.5 14.8496V14.25C1.5 13.8268 1.82675 13.5 2.25 13.5Z"
              fill="#2699C6"/>
          </svg>

          Přihlášení
        </Button>

        <Button :href="route('frontend.registration')" v-if="registrationOpened && !userLoggedIn"
                class="flex ml-4 items-center max-w-[300px] mr-2 py-[8px] text-white transition-all duration-200 text-body hover:opacity-80 bg-brand-blue">
          <svg class="mr-2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M19.1338 2.44629C19.0197 2.45032 18.9045 2.46544 18.791 2.49219L3.88184 6H10.4316L19.1348 3.95215C19.2223 3.93015 19.2897 3.96242 19.3232 3.98242C19.3557 4.00292 19.4141 4.04969 19.4346 4.13769L19.8809 6H21.4141L20.8955 3.79492C20.7885 3.33992 20.5108 2.95303 20.1133 2.70703C19.8148 2.52253 19.4762 2.43419 19.1338 2.44629ZM3.25 7C2.29252 7 1.5 7.79252 1.5 8.75V11.2646C1.50003 11.371 1.52265 11.4761 1.56638 11.573C1.6101 11.6699 1.67392 11.7564 1.75362 11.8267C1.83331 11.8971 1.92705 11.9497 2.02862 11.9811C2.13019 12.0125 2.23728 12.0219 2.34277 12.0088C2.38843 12.0031 2.44441 12 2.5 12C3.61539 12 4.5 12.8846 4.5 14C4.5 15.1154 3.61539 16 2.5 16C2.44441 16 2.38843 15.9969 2.34277 15.9912C2.23728 15.9781 2.13019 15.9875 2.02862 16.0189C1.92705 16.0503 1.83331 16.1029 1.75362 16.1733C1.67392 16.2436 1.6101 16.3301 1.56638 16.427C1.52265 16.5239 1.50003 16.629 1.5 16.7353V19.25C1.5 20.2075 2.29252 21 3.25 21H20.75C21.7075 21 22.5 20.2075 22.5 19.25V16.7353C22.5 16.629 22.4773 16.5239 22.4336 16.427C22.3899 16.3301 22.3261 16.2436 22.2464 16.1733C22.1667 16.1029 22.073 16.0503 21.9714 16.0189C21.8698 15.9875 21.7627 15.9781 21.6572 15.9912C21.6116 15.9969 21.5556 16 21.5 16C20.3846 16 19.5 15.1154 19.5 14C19.5 12.8846 20.3846 12 21.5 12C21.5556 12 21.6116 12.0031 21.6572 12.0088C21.7627 12.0219 21.8698 12.0125 21.9714 11.9811C22.073 11.9497 22.1667 11.8971 22.2464 11.8267C22.3261 11.7564 22.3899 11.6699 22.4336 11.573C22.4773 11.4761 22.5 11.371 22.5 11.2646V8.75C22.5 7.79252 21.7075 7 20.75 7H3.25ZM3.25 8.5H20.75C20.8975 8.5 21 8.60248 21 8.75V10.6016C19.3203 10.8554 18 12.2525 18 14C18 15.7475 19.3203 17.1446 21 17.3984V19.25C21 19.3975 20.8975 19.5 20.75 19.5H3.25C3.10248 19.5 3 19.3975 3 19.25V17.3984C4.67974 17.1446 6 15.7475 6 14C6 12.2525 4.67974 10.8554 3 10.6016V8.75C3 8.60248 3.10248 8.5 3.25 8.5Z"
              fill="white"/>
          </svg>
          Vstupenky
        </Button>


        <Button :href="route('frontend.user-profile')" v-if="userLoggedIn"
                class="w-40 mb-4 ml-4 text-white transition-all duration-200 hover:opacity-80 bg-brand-blue">Můj profil
        </Button>

        <a
          v-for="item in links"
          @click="close"
          :key="item.name"
          :href="item.href"
          :class="[
            item.current
              ? 'bg-indigo-50 border-indigo-500 text-indigo-700'
              : 'border-transparent text-[#2699C6] hover:bg-gray-50 hover:border-gray-300 hover:text-gray-800',
            'block pl-3 pr-4 py-2 border-l-4 text-base font-medium',
          ]"
          :aria-current="item.current ? 'page' : undefined"
        >
          {{ item.name }}
        </a>
      </div>
    </DisclosurePanel>
  </Disclosure>
</template>

<script>
import Button from "./Atomic/Button.vue";
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
} from "@headlessui/vue";
import {BellIcon, MenuIcon, XIcon} from "@heroicons/vue/outline";
import {useWindowScroll} from '@vueuse/core'
import {computed} from 'vue';
import axios from 'axios';

export default {
  components: {
    Button,
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    BellIcon,
    MenuIcon,
    XIcon,
  },

  props: {
    userLoggedIn: {
      type: Boolean,
      default: false
    },

    registrationOpened: {
      type: Boolean,
      default: false
    },
    loginOpened: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    withoutLogo() {
      return this.route().current('frontend.homepage');
    }
  },

  methods: {
    close() {
      this.$refs['toggle-button'].handleClick();
    }
  },


  setup() {
    const {x, y} = useWindowScroll()

    const shouldHaveBg = computed(() => {
      return y.value > 20;
    });

    const textBlue = computed(() => {
      return y.value > 20 || window.location.pathname !== '/';
    });

    const logout = async () => {

      try {
        const res = await axios.post(route("user.logout"), {}, {
          headers: {
            'Accept': 'application/json'
          }
        });

        if (res.status === 200) {
          window.location.href = route("frontend.homepage");
        }
      } catch (err) {
      }
    }

    return {
      x,
      y,
      shouldHaveBg,
      logout,
      textBlue
    }
  },

  data() {
    return {
      open: false,
      links: [
        {
          name: "Info",
          href: "/#info",
        },
        {
          name: "Speakeři",
          href: "/#speakeri",
        },
        {
          name: "Harmonogram",
          href: "/#harmonogram",
        },
        // {
        //   name: "Program",
        //   href: "/#program",
        // },
        // {
        //   name: "Atmosféra",
        //   href: "/#atmosfera",
        // },
        // {
        //   name: "EXEC Masterminds",
        //   href: "/#atmosfera",
        // },
        {
          name: "Partneři",
          href: "/#partneri",
        },
        {
          name: "FAQ",
          href: "/#faq",
        },
        {
          name: "Kontakt",
          href: "/#kontakt",
        },
      ],
    };
  },
};
</script>

<style>
</style>
